import axios from 'axios';

export const taskApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/tasks`,
    headers: {
        'Content-Type': 'application/json'
    }
})